const { defaultTransporterKey } = require('core');

module.exports = function updateDefaultTransporter(transporterCode) {
	window.localStorage.setItem(defaultTransporterKey, transporterCode);
};